'use strict';

class Paging {

	constructor(pagingOptions) {
		this.itemPerPage = 10;
		this.totalPage = (pagingOptions.totalPage < this.itemPerPage) ? pagingOptions.totalPage : this.itemPerPage;
		this.initialPage = pagingOptions.initialPage;
		this.location = pagingOptions.location;
		this.url = pagingOptions.url;
		this.orderSort = pagingOptions.order;
		this.orderOrder = pagingOptions.order;
		this.year = pagingOptions.year;
		this.defaultOrder = pagingOptions.defaultOrder;
		this.defaultYear = pagingOptions.defaultYear;
		this.moreBtn = pagingOptions.moreBtn;
	}

	createButton(index, value) {
		let button = document.createElement('a');
		button.classList.add('pagination-numbers__num');
		button.textContent = index;
		button.dataset.value = value;

		let hash = '';
		if (value != 1) {
			hash += 'page='+value;
		}
		if (this.orderSort != this.defaultOrder) {
			if (hash) {
				hash += '&';
			}

			hash += 'sort='+this.orderSort+'&order='+this.orderOrder;
		}

		button.href = this.url + (hash ? '?'+hash : '');

		if (this.initialPage == index) {
			button.classList.add('pagination-numbers__num--selected');
		}

		if (index == '<') {
			button.textContent = '';
			button.classList.add('pagination-numbers__num--prev');
		}

		if (index == '>') {
			button.textContent = '';
			button.classList.add('pagination-numbers__num--next');
		}

		return button;
	}

	createPagination() {
		this.location.innerHTML = '';

		if (this.initialPage != 1) {
			this.location.append(this.createButton('<', this.initialPage-1 ));
		}

		for (let i=0; i<this.totalPage; i++) {
			this.location.append(this.createButton( i+1, i+1 ));
		}

		if (this.initialPage != this.totalPage) {
			this.location.append(this.createButton('>', parseInt(this.initialPage)+1 ));
			this.createMoreBtn(parseInt(this.initialPage)+1);
		}
	}

	createMoreBtn(value) {
		this.moreBtn.innerHTML = '';
		const moreBtn = document.createElement('a');
		moreBtn.classList.add('pagination-showmore__link', 'link');
		moreBtn.textContent = 'Показать еще';

		let hash = '';
		if (value != 1) {
			hash += 'page='+value;
		}
		if (this.orderSort != this.defaultOrder) {
			if (hash) {
				hash += '&';
			}
			hash += 'order='+this.orderSort;
		}

		// if (this.order != this.defaultYear) {
		// 	if (hash) {
		// 		hash += '&';
		// 	}
		// 	hash += 'year='+this.year;
		// }

		moreBtn.href = this.url + (hash ? '?'+hash : '');
		this.moreBtn.append(moreBtn);
	}
}

function sendHintSearchList(href) {
	// Счетчик яндекса
	if (typeof ym !== "undefined") {
		ym(1131605, 'hit', window.location, {
			params: {
				title: 'Смена фото',
				target: href
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', function(){
	const dataContainer = document.querySelector('[data-catalog]'),
		itemsCountEl = document.querySelector('.search-filter__count span'),
		searchFilter = document.querySelector('.search-filter'),
		_h1 = document.querySelector('.search-list__header'),
		perelinksList = document.querySelector('.tags-list__line.tags-list__line--perelinks'),
		seoText = document.querySelector('.about-text--seo');
	// if ajaxUpdate then search-list updates by ajax on page or order change
	// else we need to give a ststic page and page or order change will reload the page
	const isAjaxUpdate = dataContainer.hasAttribute('data-ajax');


	if(isAjaxUpdate) {
		var defaultOrder = searchFilter.dataset.defaultOrder,
			defaultYear = searchFilter.dataset.defaultYear;
	}

	function parseUrl(url) {
		// searchListHash = searchListUrl.split('?'),
		let [ location, hash ] = url.split('?'),
			ajaxSearchData = {};

		// searchListLocation = searchListUrl.substr(0, searchListUrl.indexOf('?')),
		// searchListHash = searchListUrl.substr(searchListUrl.indexOf('?')+1),
		const urlJson = '{"' + decodeURI(hash).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}';
		ajaxSearchData = JSON.parse(urlJson);
		// /data/search-items.json?url=/kupit-kvartiru-kazan/&param2=2&param3=3

		if (!ajaxSearchData.hasOwnProperty('order')) {
			ajaxSearchData.order = 0;
		}
		if (!ajaxSearchData.hasOwnProperty('page')) {
			ajaxSearchData.page = 1;
		}

		if (!ajaxSearchData.hasOwnProperty('year')) {
			ajaxSearchData.order = 0;
		}

		ajaxSearchData['location'] = location;
		return ajaxSearchData;
	}

	let ajaxSearchData = {};

	if (dataContainer.hasAttribute('data-ajax')) {
		const searchListUrl = dataContainer.dataset.catalog;
		ajaxSearchData = parseUrl(searchListUrl);
	}

	function drawPagination(pageCount, searchData) {
		const pagingOptions = {
			totalPage: pageCount,
			initialPage: searchData.page,
			location: document.querySelector('[data-paging] .pagination-numbers'),
			moreBtn: document.querySelector('.pagination-showmore'),
			url : searchData.url,
			order: searchData.order,
			orderOrder: document.querySelector('.js-order').dataset.order,
			defaultOrder: defaultOrder,
			defaultYear: defaultYear
		};

		let paging = new Paging(pagingOptions);
		paging.createPagination();
	}

	let tagListHide = [];

	function initListeners() {
		const paging = document.querySelector('[data-paging]');

		if(paging) {
			paging.addEventListener('click', function clickHandler(e) {
				e.preventDefault();
				const btnPagins = e.target.closest('.pagination-numbers__num');
				const btnMore = e.target.closest('.pagination-showmore__link');

				if(btnPagins) {
					const searchData = parseUrl(btnPagins.href);
					scrollTo(0, 747);
					updatePage(searchData);
				} else if (btnMore) {
					const searchData = parseUrl(btnMore.href);
					updatePage(searchData, true);
				}
			});
		}

		const tagsBox = document.querySelector("[data-tags]");

		if(tagsBox) {
			tagsBox.addEventListener('click', function(e) {
				const moreBtn = e.target.closest(".tags-list__link.tags-list__link--showmore");
				if(moreBtn) {
					e.preventDefault();
					moreBtn.style.display = 'none';
					if(isAjaxUpdate) {
						renderTags(tagListHide, tagsBox);
					}
				}
			});
		}

	}


	initListeners();

	function renderTags(tagList, tagLine) {
		tagList.forEach((tag) => {
			const linkBox = document.createElement('div');
			linkBox.classList.add('tags-list__link');
			const link = document.createElement('a');
			link.classList.add('link');

			linkBox.appendChild(link);
			link.href = tag.href;

			link.innerHTML = `
				${tag.name}
				<span>${tag.countNum}</span>
			`;
			tagLine.appendChild(linkBox);
		});
	}


	function renderMeta(data, searchData) {

		if (data.h1) {
			_h1.textContent = data.h1;
		}

		data.meta.forEach(function(meta){
			document.querySelector('meta[name="'+meta.name+'"]').setAttribute('content', meta.value);
			if (meta.name == 'title') {
				document.title = meta.value;
			}
		});


		if (data.perelinks.length) {
			perelinksList.innerHTML = '';

			data.perelinks.forEach(function(link) {
				let linkLiBox = document.createElement('div');
				linkLiBox.classList.add('tags-list__link');
				let linkLi = document.createElement('a');
				linkLi.classList.add('link');
				linkLiBox.append(linkLi);

				linkLi.setAttribute('href', link.href);
				linkLi.textContent = link.name;

				let linkEl = document.createElement('span');
				linkEl.textContent = link.countNum;
				linkLi.append(linkEl);

				perelinksList.append(linkLiBox);
			});
		}

		// отрисовка тегов
		if(data.tags && data.tagsLimit) {
			const tagLine = document.querySelector("[data-tags]");
			let tagList = [];


			if(data.tags.length > data.tagsLimit) {
				tagList = data.tags.slice(0, data.tagsLimit);
				tagListHide = data.tags.slice(data.tagsLimit, data.tags.length - 1);
			} else {
				tagList = data.tags;
			}

			if(tagLine) {
				tagLine.innerHTML = '';

				if(isAjaxUpdate) {
					renderTags(tagList, tagLine);
				}

				if(data.tags.length > data.tagsLimit) {
					let moreBtnBox = document.createElement('div');
					let moreBtn = document.createElement('a');
					moreBtnBox.appendChild(moreBtn);
					moreBtnBox.classList.add('tags-list__link','tags-list__link--showmore');
					moreBtn.classList.add('link');
					moreBtn.innerHTML = 'Показать еще';
					moreBtn.href = '#';
					let moreBtnIcon = document.createElement('span');
					moreBtnIcon.innerHTML = `
						<svg class="showmore-icon">
							<use xlink:href="/img/icons.svg#arrow"></use>
						</svg>
					`;
					moreBtn.appendChild(moreBtnIcon);

					tagLine.appendChild(moreBtnBox);
				}
			}
		}


		if (data.pageCount) {
			drawPagination(data.pageCount, searchData);
		}

		if (data.itemsCount) {
			itemsCountEl.textContent = data.itemsCount + ' ';
		}

		if (data.seoText) {
			seoText.innerHTML = data.seoText;
		}
	}

	function updatePage(searchData, isMoreBtn = false) {
		// let query = new URLSearchParams(ajaxSearchData);

		var query = '';
		for (let key in searchData) {

			if ( (key == 'order') && (searchData[key] == defaultOrder) ) {
				continue;
			}

			if ( (key == 'page') && parseInt(searchData[key]) == 1 ) {
				continue;
			}

			query += key + '='+ searchData[key] + '&';
		}

		// query = query.slice(0, -1);

		// TODO состояние загрузки (скелетон)
		// dataContainer.classList.add('search-list__list--loading');

		// fetch(searchData.location + '?' + query, {
		fetch('/data/search-items.json' + '?' + query, {
			// method: 'post',
			method: 'get',
			// TODO зачем используется credentials
			// credentials: 'include'
			// body: query
		}).then(response => {
			return response.json();
		}).then(resp => {
			// additional см JSON
			renderMeta(resp.additional, searchData);
			renderSearchList(resp.items, isMoreBtn);
			// TODO убрать состояние загрузки
		}).catch((e)=> console.error(e));
	}

	// request to items json
	const catalog = document.querySelector('[data-catalog]');

	function renderSearchList(items, isMoreBtn = false) {
		if(!isMoreBtn) {
			catalog.innerHTML = '';
		}

		items.forEach(item => {
			if(item.type === 'item') {
				const card = renderCard(item);
				catalog.append(card);
			}
			if(item.type === 'ad') {
				catalog.insertAdjacentHTML('beforeend', item.html);
			}
		});
		slidersInit();
	}

	if(isAjaxUpdate) {
		updatePage(ajaxSearchData);
	}


	function slidersInit() {
		let srlSliders = document.querySelectorAll('.sale-prev__photo-wrp');

		srlSliders.forEach(function(slider){
			new Swiper(slider, {
				preloadImages: false,
				lazy: true,
				loop: true,
				slidesPerView: 2,
				spaceBetween: 4,
				navigation: {
					nextEl: '.sale-prev__slider-next',
					prevEl: '.sale-prev__slider-prev',
				},
				on: {
					slideChange: function () {
						const currentIndex = slider.parentNode.querySelector('[data-current-index]');
						if(currentIndex) {
							currentIndex.textContent = this.realIndex + 1;
						}
						sendHintSearchList();
					}
				}
			});

		});
	}

	slidersInit();

	// render
	function renderCard(card) {
		const cardHtml = document.createElement('div');
		cardHtml.classList.add('sale-prev');
		let html = `
		<div class="sale-prev__main">
			<div class="sale-prev__main-info">
				<div class="sale-prev__main-header">
					<a class="sale-prev__header link" href="#">${card.header}</a>
					<div class="sale-prev__descr">
						<a class="link" href="#">${card.descr.text}</a>
					</div>
					<span class="sale-prev__label">
						<span>Новый</span>
					</span>
				</div>
				<div class="sale-prev__price">
					<div class="sale-prev__main-cost">
						<span class="sale-prev__price-cost">${card.price}</span>
						<span class="sale-prev__label sale-prev__label--right">
							<span>Нормальная цена</span>
						</span>
						<span class="sale-prev__price-descr">${card.priceWithoutDiscount}</span>
						<span class="sale-prev__price-period">От 15 000 руб/мес</span>
					</div>
					<div class="sale-prev__main-tech">
						<p>${card.year}</p>
						<p>${card.mileage}</p>
					</div>
				</div>
				<div class="sale-prev__photo-part">
					<div class="sale-prev__photo-wrp sale-prev__photo-wrp--slider swiper-container">
						<a class="swiper-wrapper" href="#">
							${card.photos.map(photo => `
								<div class="sale-prev__slide swiper-slide">
									<img class="sale-prev__photo" src="${photo}" alt="">
								</div>
							`).join('')}
						</a>
						<div class="sale-prev__slider-prev swiper-button-prev swiper-button-white"></div>
						<div class="sale-prev__slider-next swiper-button-next swiper-button-white"></div>
					</div>
					<p class="sale-prev__photo-count">
						<span class="current-index" data-current-index>1</span> / ${card.photos.length}
					</p>
				</div>
				<p class="sale-prev__tech">${card.techDescr}</p>
				<div class="sale-prev__shop">
					<a class="sale-prev__shop-link link" href="${card.shop.link}">${card.shop.name}</a> <span>${card.shop.countCars}</span>
				</div>
				<div class="sale-prev__checks">
					${card.checksItems.map(checkItem => `${checkItem}`).join('')}
				</div>
			</div>
			<div class="sale-prev__footer">
				<div class="sale-prev__footer-left">
					<p class="sale-prev__area">${card.area} <span class="text text--green">+55 км</span>, ${card.date}<span class="eye-counter">${card.views}</span></p>
				</div>
				<div class="sale-prev__footer-right">
					<div class="icon-btn-wrp">
						<a class="icon-btn icon-btn--call icon-btn--call-pc" data-id="${card.itemId}" data-show-ad-tel>Показать телефон</a>
						<a class="icon-btn icon-btn--compare" data-btn-compare data-type="ad" data-id="${card.itemId}" href="//www.110km.ru/compare/${card.itemName}_vs" target="_blank" title="Добавить к сравнению">
							<i class="icon"></i>
						</a>
						<a class="icon-btn icon-btn--write" data-url data-popup-target="popup--send-msg" data-id="${card.itemId}" data-show-msg-to-slr title="Написать автору">
							<i class="icon"></i>
						</a>
						<a class="icon-btn icon-btn--fav" data-title="${card.header}" data-url="${card.shop.link}" data-add-to-fav data-id="${card.itemId}" target="_blank" href="//110km.ru/user/bookmarks/" title="Добавить в избранное / Убрать из избранного">
							<i class="icon"></i>
						</a>
					</div>
					<a class="icon-btn icon-btn--call icon-btn--call-mobile" data-id="${card.itemId}" data-show-ad-tel>Позвонить</a>
				</div>
			</div>
		</div>
		`;
		cardHtml.innerHTML = html;
		return cardHtml;
	}

	// show tels
	document.addEventListener('click', function(e){
		let btn = e.target.closest('[data-show-ad-tel]');
		if (btn && !btn.hasAttribute('href')) {
			e.preventDefault();

			let sri = btn.closest('.sale-prev'),
				data = "agentId=" + sri.uid ? sri.uid : sri.dataset.id,
				telEls = sri.querySelectorAll('[data-show-ad-tel]');

			fetch('/announcements/showPhone/', {
			// fetch('/data/showTel.json', {
				method: 'post',
				body: new URLSearchParams({
					'agentId': sri.uid ? sri.uid : sri.dataset.id
				}),
				credentials: 'include',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
				}
			}).then(response => {
				return response.json();
			}).then(resp => {
				telEls.forEach(function(tel){
					tel.textContent = resp.tel;
					tel.setAttribute('href', 'tel:'+resp.tel);

					if (window.innerWidth < 768){
						window.location = 'tel:'+resp.tel;
					}
				});

			});
		}
	});

	// add to favorites
	if(dataContainer) {
		dataContainer.addEventListener('click', function(e){
			var favBtn = e.target.closest('[data-add-to-fav]');

			if (!favBtn){
				return;
			}

			if (favBtn.classList.contains('disabled-link')){
				e.stopPropagation();
				e.preventDefault();
				return false;
			}

			if (!favBtn.hasAttribute('href') || !favBtn.classList.contains('active')){
				e.stopPropagation();
				e.preventDefault();

				var request = new XMLHttpRequest();
				// request.open('get', './data/test.json', true);
				request.open('post', 'https://110km.ru/user/add_bookmark/', true);
				request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=utf-8');

				request.onreadystatechange = function () {
					if (this.readyState != 4) return;

					// var resp = JSON.parse(this.response);
					var resp = this.response;

					if (resp == "error: unregistered") {
						var loginForm = document.querySelector('.js-login-form');
						loginForm.closest('.popup').classList.add('popup--active');
					} else {
						favBtn.classList.toggle('active');
					}

					favBtn.classList.remove('disabled-link');
				};

				request.onerror = function () {
					showError('Add to favourite connection error');
					favBtn.classList.remove('disabled-link');
				};

				favBtn.classList.add('disabled-link');
				var data = "title=" + favBtn.dataset.title + "&url=" + favBtn.dataset.url;
				request.send(data);
			}
		});
	}


	// sorting
	const	sortingSelects = document.querySelectorAll(".slp-form__select--rating .picker__select");

	sortingSelects.forEach(function(sortEl) {
		// change sort
		sortEl.addEventListener('change', function(e){
			var orderEl = document.querySelector('.js-order'),
					createdEl = document.querySelector('.js-created');

			// var sortHash = '/searchcar/?created=' + createdEl.value + 'sort=' + orderEl.value + '&order=' + orderEl.options[orderEl.selectedIndex].dataset.order ;

			if (isAjaxUpdate) {
				// const name = sortEl.name;
				ajaxSearchData.order = sortEl.options[sortEl.selectedIndex].dataset.order;
				ajaxSearchData.sort = sortEl.value;

				// ajaxSearchData[name] = sortEl.value;
				ajaxSearchData.page = 1;
				updatePage(ajaxSearchData);
				// console.log(ajaxSearchData);
			} else {
				let dataOrder = orderEl.options[orderEl.selectedIndex].dataset.order,
						valOrder = orderEl.options[orderEl.selectedIndex].dataset.sort,
						valCreated = createdEl.value;

				// window.location = window.location.origin + window.location.pathname + '?o=' + sortEl.value;
					var url = window.location.href;
					// var url = 'https://stpetersburg.110km.ru/prodazha/bmw/year-2020/?new_layout=3&order=desc&sort=updated_at&created=asc';

					function replaceUrlParam(url, paramName, paramValue) {
						if (paramValue == null) {
							paramValue = '';
						}
						var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
						if (url.search(pattern)>=0) {
							return url.replace(pattern,'$1' + paramValue + '$2');
						}
						url = url.replace(/[?#]$/,'');
						return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
					};
				
					var urlOrder, sortUrl;

					if(dataOrder || dataOrder == '') {
						urlOrder = replaceUrlParam(url, 'order', dataOrder);
						console.log(dataOrder);
					} if(valOrder || valOrder == '') {
						if(urlOrder) {
							sortUrl = replaceUrlParam(urlOrder, 'sort', valOrder);
						} else {
							sortUrl = replaceUrlParam(url, 'sort', valOrder);
						}
					} if(valCreated || valCreated == '') {
						if(sortUrl) {
							sortUrl = replaceUrlParam(sortUrl, 'created', valCreated);
						} else {
							sortUrl = replaceUrlParam(url, 'created', valCreated);
						}
					}
				
					location.href = sortUrl;
			}
		});
	})


	/*
	* Popups
	*/
	// Close popup when click on close btn, or click outside popup
	document.addEventListener('click', function(e){
		var tg = e.target;

		if (tg.classList.contains('popup')){

			if (tg.hasAttribute('data-delete')){
				tg.remove();
			} else {
				tg.classList.remove('popup--active');
			}

			document.body.style.overflow = '';
		}
	});

	document.addEventListener('click', function(e){
		var tg = e.target;
		if (tg.classList.contains('popup__close-btn') || tg.hasAttribute('data-close-popup')){
			var popup = tg.closest('.popup');

			if (popup.hasAttribute('data-delete')){
				popup.remove();
			} else {
				popup.classList.remove('popup--active');
			}

			document.body.style.overflow = '';
		}
	});
	// OPEN POPUPS
	document.addEventListener('click', function(e){
		const target = e.target.closest('[data-popup-target]');

		if (target) {
			e.preventDefault();
			e.stopPropagation();

			const popup = document.querySelector('.'+target.dataset.popupTarget);

			// reset popup data
			const hiddenElements = popup.querySelectorAll('.js-hide-on-result');
			if (hiddenElements.length) {
				hiddenElements.forEach(function(el){
					el.style.display = '';
				});
			}
			const showedResult = popup.querySelector('.js-show-on-result');
			if (showedResult) {
				showedResult.innerHTML = '';
			}

			const form = popup.querySelector('form');
			if (form) {
				form.reset();
			}

			// insert data
			if (target.hasAttribute('data-input-values')) {
				let data = JSON.parse(target.dataset.inputValues);
				for (let key in data) {
					popup.querySelector('[name="'+key+'"]').value = data[key];
				}
			}

			popup.classList.add('popup--active');
			document.body.style.overflow = 'hidden';

			// grecaptcha.reset();

			return false;
		}
	});

	// const showMoreTags = document.querySelector(".tags-list__link--showmore"),
	// 			hidingTags = document.querySelectorAll(".tags-list__link.hide"),
	// 			moreBlock = document.querySelector(".tags-list__link.tags-list__link--showmore");

	// showMoreTags.addEventListener('click', function() {
	// 	hidingTags.forEach(function(tag) {
	// 		tag.classList.remove('hide');
	// 		moreBlock.classList.add('hide');
	// 	})
	// })

	// VUE form
	// const requiredInputs = document.querySelectorAll('[data-required'),
	// 			submitBtn = document.querySelector('.slp-form__show-btn'),
	// 			form = document.querySelector('.slp-form__container')
	// 			formInputs = form.querySelectorAll('.picker__header span', '.slp-form__input');

	const slpForm = document.querySelector('.js-slp-form'),
		slpFormInputRegion = slpForm.querySelectorAll('.js-slp-region input[type="radio"]'),
		slpFormInputs = slpForm.querySelectorAll('.picker__select, input[type="text"].slp-form__input, input[type="radio"], .js-checkboxes input[type="checkbox"]');

	const initialValue = {};
	const initialReset = {};

	function clearRegionVal() {
		slpFormInputRegion.forEach(function(item) {
			item.value = '';
		});
	}

	slpFormInputs.forEach(item => {
		// initialValue
		if(item.hasAttribute('multiple')) {
			var result = [];
			function getSelectValues(item) {
				var options = item && item.options;
				var opt;

				for (var i=0, iLen=options.length; i<iLen; i++) {
					opt = options[i];

					if (opt.selected) {
						result.push(opt.value || opt.text);
					}
				}
			};

			getSelectValues(item);
			initialValue[item.name] = result;

		} else if (item.type == 'radio') {
			if (item.checked) {
				initialValue[item.name] = item.value;
			}
		} else if (item.type == 'checkbox') {
			initialValue[item.name] = item.checked;
		} else {
			initialValue[item.name] = item.value;
		}

		// initialReset
		if(item.hasAttribute('multiple')) {
			var result = [];
			function getSelectValues(item) {
				var options = item && item.options;
				var opt;

				for (var i=0, iLen=options.length; i<iLen; i++) {
					opt = options[i];

					if (opt.selected) {
						result.push(opt.value || opt.text);
					}
				}
			};

			getSelectValues(item);
			initialReset[item.name] = '';

		} else if (item.type == 'checkbox') {
			initialReset[item.name] = '';
		} else {
			initialReset[item.name] = '';
		}
	});


	var initDataModel = {
		...initialValue
	};

	// console.log(initDataModel);

	var searchFormVue = {
		data() {
			return {
				pickers: [],
				dataModel: initDataModel,
				isFullForm: false,
				models: [],
				equipments: [],
			}
		},
		watch: {
			dataModel: {
				handler(val, oldVal) {
					// console.log('изменилось свойство c', val);
					// console.log(initDataModel);
					window.formSearchValue = val;
				},
				deep: true
			}
		},
		mounted() {
			window.formSearchValue = this.dataModel;
		},
		methods: {
			// https://stpetersburg.110km.ru/prodazha/acura/rsx/?local=30712&brand=acura&model=rsx&complete_set%5B%5D=23496&complete_set%5B%5D=23497&p_from=4&p_to=5&year_from=2020&year_to=2020&r_from=3&r_to=7&c_from=400&c_to=800&m_from=8&m_to=9&body%5B%5D=2&transmission%5B%5D=5&engine%5B%5D=2&drive%5B%5D=2&color%5B%5D=11&wheel=1&accident=true&old_car=true&advanced=1
			getOptions(data) {
				return data.map(({id, name}) => {
					return `<option value="${id}">${name}</option>`;
				});
			},
			submitHandler() {
				let queryForm = new FormData();
				let inputs = document.querySelectorAll(".js-slp-form input, .js-slp-form select");
				
				for (let i = 0, element; element = inputs[i++];) {

						if (element.type === 'checkbox' && !element.checked) continue;
						if (element.type === 'radio' && !element.checked) continue;

						let name = element.name;
						let value = element.value;

						if (element.name === 'new_old_car' && element.value === '1') {
							name = 'new_car';
							value = 'true';
						}
						if (element.name === 'new_old_car' && element.value === '2') {
							name = 'old_car';
							value = 'true';
						}

						value = value.replace(/(\d)(?= \d) /g, '$1');

						if(element.hasAttribute('multiple')) {
							function getSelectValues(element) {
								var options = element && element.options;
								var opt;
				
								for (var i=0, iLen=options.length; i<iLen; i++) {
									opt = options[i];
				
									if (opt.selected) {
										if(opt.value) {
											queryForm.append(element.name + '[]', opt.value);
										}
									}
								}
							};
							getSelectValues(element);
						} else {
							if(name && value) {
								queryForm.append(name, value);
							}
						}
				}
  
				let queryString = new URLSearchParams(queryForm).toString();

				fetch('/announcements/redirectSearch/?' + queryString, {
					method: 'post',
				}).then(response => {
					console.log('https://buy.110km.ru/?' + queryString);
					return response.json();
				}).then(resp => {
					if (resp.action) {
						location.href = resp.action;
					}
					else {
						location.href = 'https://buy.110km.ru/?' + queryString;
					}
				}).catch((e)=> console.error(e));

				// updatePage(data);
			},

			modelHandler() {
				const data = {
					...this.dataModel
				}

				let queryData = '';
				for (let key in data) {

					if ( (key == 'brand') ) {
						queryData += key + '='+ data[key];
					}
				}
				// var resp = JSON.parse(this.response);
				// fetch(searchData.location + '?' + query, {
				fetch('https://110km.ru/models/getbybrand/', {
				// fetch('data/getmodels.json', {

					method: 'post',
					body: queryData,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
					}
				}).then(response => {
					return response.json();
				}).then(resp => {
					if(this.$refs.modeltype.classList.contains('picker--disabled')) {
						this.$refs.modeltype.classList.remove('picker--disabled');
					};
					this.$refs.selectModeltype.innerHTML = this.getOptions(resp.models);
					this.$nextTick(()=> pickerObj.rebuildPicker(this.$refs.modeltype));
				}).catch((e)=> console.error(e));
			},

			equipmentHandler() {
				const data = {
					...this.dataModel
				}

				let queryModeltype = '';
				for (let key in data) {

					if ( (key == 'model') ) {
						queryModeltype += (queryModeltype.length > 0 ? '&' : '') + key + '=' + data[key];
					}

					if ( (key == 'brand') ) {
						queryModeltype += (queryModeltype.length > 0 ? '&' : '') + key + '=' + data[key];
					}
				}
				// var resp = JSON.parse(this.response);
				// fetch(searchData.location + '?' + query, {
				fetch('https://110km.ru/tth/getbymodel/', {
				// fetch('data/getbrand.json', {

					method: 'post',
					body: queryModeltype,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
					}
				}).then(response => {
					return response.json();
				}).then(resp => {
					// this.equipments = resp.equipments;
					if(this.$refs.equipment.classList.contains('picker--disabled')) {
						this.$refs.equipment.classList.remove('picker--disabled');
					};
					this.$refs.selectEquipment.innerHTML = this.getOptions(resp.equipments);
					this.$nextTick(()=> pickerObj.rebuildPicker(this.$refs.equipment));
				}).catch((e)=> console.error(e));
			},

			rebuildPickers() {
				this.pickers = document.querySelectorAll('.picker--multi, .picker--single');

				this.pickers.forEach(function(picker) {
					pickerObj.resetPicker(picker);
				})
			},

			resetForm() {
				this.dataModel = initialReset;
				document.querySelector('.js-model').innerHTML = '';
				document.querySelector('.js-equipment').innerHTML = '';

				this.rebuildPickers();
			},

			showFullForm() {
				this.isFullForm = !this.isFullForm;
			}
		}
	}

	var formVueData = Vue.createApp(searchFormVue);
	formVueData.mount('.slp-form');

	// STATIC html
	// add round up mask for inputs
	var inputs = document.querySelectorAll('[data-round]');
	inputs.forEach(function(input){
		var numberMask = IMask(
			input,
			{
				mask: Number,
				min: 1,
				max: 10000000,
				thousandsSeparator: ' '
			});
	});

	// form tabs
	const searchForm = document.querySelector(".slp-form"),
		searchFormBox = document.querySelector(".slp-form__box"),
		checklistBtnsMulti = searchForm.querySelectorAll('.checklist--multi .checklist__btn'),
		checklistBtnsSimple = searchForm.querySelectorAll('.checklist--simple .checklist__btn');


	for (let elem of checklistBtnsMulti) {
		elem.addEventListener('click', (e) => {
			for (let item of checklistBtnsMulti) {
				item.classList.remove('active');
				searchFormBox.classList.remove('all', 'new', 'old');
			}
			elem.classList.add('active');

			const targetPrev = e.target;

			if(targetPrev.closest('.checklist__input')) {
				const target = targetPrev.closest('.checklist__input').value;
				searchFormBox.classList.add(target);
			}
		})
	}

	for (let elem of checklistBtnsSimple) {
		elem.addEventListener("click", () => {
			for (let item of checklistBtnsSimple) {
				item.classList.remove('active');
			}
			elem.classList.add('active');
		});
	}

	/*
	* Picking region
	*/
	var regionsAll,
		request = new XMLHttpRequest(),
		regionsPopup = document.querySelector('.popup--regions'),
		regionsList = document.querySelector('.region-list'),
		regionSearchLine = document.querySelector('input[name="region-search"]');

	let showCities = false;

	function drawRegions(regions) {

		if(regionsList) {
			regionsList.innerHTML = '';
		}

		Object.values(regions).forEach(function(region){

			var li = document.createElement('div');
			li.classList.add('region-list__item');

			if (region.hasOwnProperty('name')) {
				var area = document.createElement('div');
				area.classList.add('region-list__area');

				var areaLink = document.createElement('a');
				areaLink.classList.add('link', 'link--grey');
				areaLink.href = region.url;
				areaLink.textContent = region.name;
				areaLink.setAttribute('data-action', region.action);
				areaLink.setAttribute('data-region', region.id);
				area.appendChild(areaLink);

				li.appendChild(area);
			}

			var citiesList = document.createElement('ul');
			citiesList.classList.add('region-list__cities');

			if(showCities) {
				citiesList.classList.add('active');
			}

			region.items.forEach(function(subreg){

				var citiesLi = document.createElement('li');
				citiesLi.classList.add('region-list__city');

				var cityLink = document.createElement('a');
				cityLink.classList.add('link', 'link--grey');
				cityLink.href = subreg.url;
				cityLink.textContent = subreg.name;
				cityLink.setAttribute('data-action', subreg.action);
				cityLink.setAttribute('data-region', subreg.id);
				citiesLi.appendChild(cityLink);

				citiesList.appendChild(citiesLi);
			})

			if (citiesList.hasChildNodes()){
				li.appendChild(citiesList);
			}

			if (li.hasChildNodes()){
				if(regionsList) {
					regionsList.appendChild(li);
				}
			}
		});
	}

	if(regionSearchLine) {
		regionSearchLine.addEventListener('input', function(){
			var val = this.value.trim(),
					filteredRegions = [];

			if(val == '') {
				showCities = false;
			} else {
				showCities = true;
			}

			Object.values(regionsAll).forEach(function(region){
				var filteredRegion = {};

				if (region.name.toLowerCase().indexOf(val.toLowerCase()) != -1) {
					filteredRegion.name = region.name;
					filteredRegion.url = region.url;
					filteredRegion.id = region.id;
					filteredRegion.action = region.action;
				}

				filteredRegion.items = [];
				region.items.forEach(function(city){
					if (city.name.toLowerCase().indexOf(val.toLowerCase()) != -1) {
						filteredRegion.items.push(city);
					}
				})
				filteredRegions.push(filteredRegion);
			});
			console.log('city-list', filteredRegions);

			drawRegions(filteredRegions);
		});
	}

	// request.open('get', '/data/get-cities.json', true);
	request.open('get', 'https://110km.ru/default/getcities/', true);
	request.onreadystatechange = function () {
		if (this.readyState != 4) return;

		var resp = JSON.parse(this.response);
		regionsAll = resp.regions;
		drawRegions(regionsAll);
	};

	request.onerror = function () {
		console.log('get cities: connection error');
		submitBtn.disabled = false;
	};


	regionsPopup.addEventListener('click', function(e) {
		const regionLink = e.target.closest('.link');

		if (regionLink) {
			e.preventDefault();

			var regionOther = document.querySelector('.js-change-region');
			regionOther.value = regionLink.dataset.region;
			regionOther.checked = true;

			// location.href = regionLink.dataset.action + query;
			searchFormVue.methods.submitHandler();
		}
	});

	request.send();

	// переход с пустого списка
	const emptyListLink = document.querySelector('.js-gofrom-empty');


	if(emptyListLink) {
		emptyListLink.addEventListener('click', function(e){
			e.preventDefault();
			clearRegionVal();
			searchFormVue.methods.submitHandler();
		});
	}

	// отправка Письмо продавцу
	const msgForm = document.querySelector('.msg-to-slr'),
			msgWrp = document.getElementById('popupContent');

	if (msgForm) {
		const msgTel = msgForm.querySelector('.js-msg-tel');

		IMask(msgTel, {
			mask: '+{7}(000)000-00-00',
		});

		// render recaptcha
		let recaptcha_ordinary;
		const recaptchaOrdinaryBox = document.getElementById("recaptcha_ordinary");

		var onloadCallback = function() {
			if(recaptchaOrdinaryBox) {
				recaptcha_ordinary = grecaptcha.render('recaptcha_ordinary', {
					'sitekey' : '6LcHoyUUAAAAAL39NwAVnUrXpQMDvb7sXx3rcOKb'
				});
			}
		};

		window.onloadCallback = onloadCallback;

		// submit msg-form
		const submitBtn = msgForm.querySelector('.msg-to-slr__submit-btn');

		submitBtn.addEventListener('click', function (e) {
			e.preventDefault();
			
			// submit form
			const nameInput = msgForm.querySelector('input[name="addmess[myname]"]'),
				emailInput = msgForm.querySelector('input[name="addmess[myemail]"]'),
				telInput = msgForm.querySelector('input[name="addmess[tel]"]'),
				msgInput = msgForm.querySelector('textarea[name="addmess[message]"]'),
				agreeCheck = msgForm.querySelector('input[name="addmess[agree]"]'),
				error = msgForm.querySelector('.msg-to-slr__error-text');

			// form validation
			error.textContent = 'Заполните обязательные поля';

			if (!nameInput.value) {
				nameInput.classList.add('input-line__input--error');
				return;
			}
			nameInput.classList.remove('input-line__input--error');
	
			if (!emailInput.value.match(/.+@.+\..+/i)) {
				emailInput.classList.add('input-line__input--error');
				return;
			}
			emailInput.classList.remove('input-line__input--error');
	
			if (telInput.value.length < 16) {
				telInput.classList.add('input-line__input--error');
				return;
			}
			telInput.classList.remove('input-line__input--error');
	
			if (!msgInput.value) {
				msgInput.classList.add('input-line__input--error');
				return;
			}
			msgInput.classList.remove('input-line__input--error');
	
			if (!agreeCheck.checked) {
				agreeCheck.closest('.check').classList.add('check--error');
				return;
			}
			agreeCheck.closest('.check').classList.remove('check--error');

			if (error) {
				error.textContent = '';
			}

			let request = new XMLHttpRequest();
			request.open('post', msgForm.getAttribute('action'), true);
			// request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=utf-8');
	
			request.onreadystatechange = function () {
				if (this.readyState != 4) return;
	
				let resp = JSON.parse(this.response);
	
				if (!resp.err) {
					msgWrp.innerHTML = resp.resultHtml;
				} else {
					btn.disabled = false;
	
					error.classList.add('msg-to-slr__error-text');
					error.innerHTML = resp.msg;
				}
			};
	
			request.onerror = function () {
				console.log('Send message to seller connection error');
				btn.disabled = false;
			};
	
			submitBtn.disabled = true;
			let fd = new FormData(msgForm);

			request.send(fd);
			// end of submit form
		});
	};

	// передаю id объявления в Написать продавцу
	// работает только на статике, для динамики json - надо setTimeOut добавлять
	const writeBtns = document.querySelectorAll('.icon-btn--write');

	writeBtns.forEach(function(btn){
		btn.addEventListener('click', function(){
			msgForm.querySelector('input[name="ide"]').value = btn.dataset.id;
			msgForm.action = btn.dataset.url;
		})
	});

})